/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Delete_Modal_DescriptionInputs */

const es_user_profile_api_keys_delete_modal_description = /** @type {(inputs: User_Profile_Api_Keys_Delete_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto revocará permanentemente tu clave API. Cualquier integración que la use dejará de funcionar inmediatamente.`)
};

const en_user_profile_api_keys_delete_modal_description = /** @type {(inputs: User_Profile_Api_Keys_Delete_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will permanently revoke your API key. Any integrations using it will stop working immediately.`)
};

/**
* | output |
* | --- |
* | "This will permanently revoke your API key. Any integrations using it will stop working immediately." |
*
* @param {User_Profile_Api_Keys_Delete_Modal_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_delete_modal_description = /** @type {((inputs?: User_Profile_Api_Keys_Delete_Modal_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Delete_Modal_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_delete_modal_description(inputs)
	return en_user_profile_api_keys_delete_modal_description(inputs)
});
export { user_profile_api_keys_delete_modal_description as "user.profile.api_keys.delete_modal.description" }